// extracted by mini-css-extract-plugin
export default {"container":"create_container__azA11","header":"create_header__Gi5Av","title":"create_title__eBnPj"};